import _ from 'lodash';
import update from 'immutability-helper';
import { toast } from 'qw-ui-lib-v2';
import reduceReducers from 'reduce-reducers';
import { validateSchema } from '../common/validations';
import I18n from '../../config/i18n';
import enums from '../common/utils/enums';
import { convertBandwidthInUnits } from '../common/utils';
import qwPartners from '../common/clients/qwPartners';
import { showAppBusy, handleAppError } from './app';

const initialState = {
  drives: [
    {
      driveType: enums.DriveTypes.CRU,
      totalStock: 0,
    },
  ],
  bandwidth: {
    value: null,
    unit: enums.BandwidthUnits.MEGA_BITS_PER_SECOND,
  },
  errors: {},
  receivedAt: Date.now(),
};

const RECEIVE = 'inventory/RECEIVE';
const UPDATE_DRIVES = 'inventory/UPDATE_DRIVES';
const UPDATE_BANDWIDTH = 'inventory/UPDATE_BANDWIDTH';
const SCHEMA_ID = 'http://partners.qubewire.com/schemas/updateDriveInventory';
const ACCOUNT_FIELDS = ['drives', 'bandwidth'];

export function receiveInventory(account) {
  const inventory = _.pick(account, ACCOUNT_FIELDS);
  if (_.isEmpty(inventory)) {
    return;
  }

  inventory.bandwidth = convertBandwidthInUnits(inventory.bandwidth);

  return { type: RECEIVE, payload: inventory };
}

export function updateDriveInventory(payload) {
  return { type: UPDATE_DRIVES, payload };
}

export function updateBandwidth(payload) {
  return { type: UPDATE_BANDWIDTH, payload };
}

export function saveDriveInventory(partnerId, drives) {
  return (dispatch) => {
    dispatch(showAppBusy(true));
    return qwPartners
      .put(`/v1/partner/${partnerId}`, { drives })
      .then(() => {
        dispatch(updateDriveInventory(drives));
        dispatch(showAppBusy(false));
        toast.add({
          message: I18n.t('driveInventorySaveSuccess'),
          variant: 'positive',
          placement: 'top-right',
        });
      })
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(handleAppError(error, I18n.t('failedToSaveDriveInventory')));
        toast.add({
          message: I18n.t('failedToSaveDriveInventory'),
          variant: 'negative',
          placement: 'top-right',
        });
      });
  };
}

function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case RECEIVE:
      return Object.assign({}, initialState, payload, {
        receivedAt: Date.now(),
      });

    case UPDATE_DRIVES:
      return update(state, { drives: { $set: payload } });

    case UPDATE_BANDWIDTH:
      return update(state, { bandwidth: { $set: payload } });

    default:
      return state;
  }
}

function validator(state = initialState, action) {
  let { type } = action;
  switch (type) {
    case RECEIVE:
    case UPDATE_DRIVES:
    case UPDATE_BANDWIDTH: {
      let errors = validateSchema(state, SCHEMA_ID);
      return Object.assign({}, state, { errors });
    }
    default:
      return state;
  }
}

export default reduceReducers(reducer, validator);
